import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { InvoiceService } from 'api';
import { StyledButton } from 'components/Buttons';
import { LoaderFullScreen } from 'components/Loaders/LoaderFullScreen';
import { CorrectiveInvoice, Invoice } from 'pages/invoices/invoices.types';
import { useTranslation } from 'react-i18next';
import { isInvoiceCorrective } from 'utils/invoiceFunctions.utils';
import * as S from '../InvoiceDetails/components/InvoiceLinesPanel/InvoiceLinesPanel.css';
import { prepareRemoveAllLinesBody } from './InvoiceForm.utils';

type Props = {
  open: boolean;
  invoiceData: Invoice | CorrectiveInvoice;
  onClose: () => void;
  onSubmit: () => void;
};

export const ConfirmCurrencyChangeDialog = ({
  open,
  invoiceData,
  onClose,
  onSubmit,
}: Props) => {
  const { t } = useTranslation(['misc']);

  const { removeAllLines, loading } = InvoiceService.useRemoveAllLines();

  const handleSubmit = async () => {
    const payload = prepareRemoveAllLinesBody(invoiceData);
    const isCorrective = isInvoiceCorrective(invoiceData.invoiceClass);
    await removeAllLines(invoiceData.id, isCorrective, payload);
    await onSubmit();
    onClose();
  };

  return (
    <>
      <LoaderFullScreen loading={loading} />
      <S.StyledDialog open={open} onClose={onClose}>
        <DialogTitle>{t('modal.header', { ns: 'misc' })}</DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            {t('modal.currencyWarningBody', { ns: 'misc' })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <StyledButton $primary onClick={handleSubmit}>
            {t('boolean.true', { ns: 'misc' })}
          </StyledButton>
          <StyledButton onClick={onClose}>
            {t('boolean.false', { ns: 'misc' })}
          </StyledButton>
        </DialogActions>
      </S.StyledDialog>
    </>
  );
};
